// extracted by mini-css-extract-plugin
export default {"withdraw_container":"style_withdraw_container__DtM3e","withdraw_btn":"style_withdraw_btn__83rPj"};